import { getBrowserPostFile } from "./webPostFiles";

// Browser uploads stay behind this FileSystem-compatible boundary. Only blobs
// prepared by the composer are readable; arbitrary URLs cannot be attached.
export function createUploadFile(uri: string) {
  const blob = getBrowserPostFile(uri);
  return {
    exists: !!blob,
    size: blob?.size ?? 0,
    async bytes() {
      if (!blob) throw new Error("Browser file unavailable.");
      return new Uint8Array(await blob.arrayBuffer());
    },
  };
}
